module.exports = __webpack_public_path__ + "img/Weapon_279.ee5214b4.png";